import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

// Load store modules dynamically.
const requireContext = require.context('./modules', false, /.*\.js$/)

const modules = requireContext.keys()
  .map(file =>
    [file.replace(/(^.\/)|(\.js$)/g, ''), requireContext(file)]
  )
  .reduce((modules, [name, module]) => {
    modules[name] = module
    return modules
  }, {})

//
// Original
// export default new Vuex.Store({
//   strict: process.env.NODE_ENV !== 'production',
//   modules,
//   plugins: [createPersistedState({ storage: window.sessionStorage })]
// })

// neu
const vuePersist = {
  reducer: state => ({
    saved: saved.lang
  }),
  saveState: (key, state, storage) => {
    requestIdleCallback(() => {
      storage.setItem(key, JSON.stringify(state))
    })
  }
}

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules,
  plugins: [createPersistedState({
    reducer: (persistedState) => {
      const stateFilter = Object.assign({}, persistedState)
      const blackList = ['message', 'route', 'suche']

      blackList.forEach((item) => {
        delete stateFilter[item]
      })

      return stateFilter
    }
  }
  )]
})
